module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div id="grid_selector"></div>\n<div id="photos_region"></div>\n<div id="footer_region"></div>';

}
return __p
}